import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Footer from '../components/Footer/Footer'
import FAQS from '../components/FAQS/FAQS'
import MasterCalendar from '../components/MasterCalendar/MasterCalendar'


const Resources = () => {
  const resFaq = [
    { id: 1, 
      question: 'Recreation Team Communication', 
      answer: 'For clear communication we request recreation coaches to use GroupMe App', 
      url : <a href="https://groupme.com/en-US/" target="_blank" rel="noopener noreferrer">groupme.com</a>},
    { id: 2,
       question: 'Soccer Gear', 
       answer: "Soccer shin guards and soccer specific boots(cleats) can be purchased at Dick's Sporting goods. We also recommend you look at soccer.com for full inventory of soccer specific gear.", 
       url: <a href="https://www.dickssportinggoods.com/" target="_blank" rel="noopener noreferrer">SOCCER.COM</a> },
    { id: 3, 
      question: 'Equipment', 
      answer: 'If your child has a ball we encourage them to bring it to practices and match day Saturday. All players must wear shin guards and soccer boots/cleat to both practices and matches. Practices and matches are played in all weather conditions, minus lighting. We encourage players and coaches to bring weather permitting gear.' },
    { id: 4,
      question: 'Prepare for training/practice',
      answer: 'We encourage all players to wear either a white, gray, black, red, or purple a top to training. This also includes wearing athletic shorts or pants. Players must wear shin guards, soccer socks, and soccer boots/cleats.'},
  ]

  const comFaq = [
    { id: 1, 
      question: 'Competitive Team Communication', 
      answer: 'For clear communication we request competitive coaches to use TeamSnap App', 
      url : <a href="https://www.teamsnap.com/" target="_blank" rel="noopener noreferrer">teamsnap.com</a> },
    { id: 2, 
      question: 'Soccer Gear', 
      answer: "Soccer shin guards and soccer specific boots(cleats) can be purchased at Dick's Sporting goods. We also recommend you look at soccer.com for full inventory of soccer specific gear.", url: <a href="https://www.soccer.com/" target="_blank" rel="noopener noreferrer">SOCCER.COM</a> },
    { id : 3,
      question : 'Prepare for training/practice',
      answer : 'We encourage all players to wear either a white, gray, black, red, or a purple top to training.'
    },
    { id : 4,
      question : 'IYSA Wavier',
      answer : 'Every competitive player must complete and submit a IYSA waiver in order to be eligible to play in ILLOWA and tournaments.',
      url : <a href="http://www.illowa.org/doclib/IYSA%20MEDICAL%20RELEASE%202022.pdf" target="_blank" rel="noopener noreferrer">IYSA MEDICAL RELEASE FORM</a> },
    

  ]
  return (
    <div>
      <Navbar />
      <div className="app__background section__padding">
        <div className="app__content">
          <h1 className="headtext__roboto">Resources</h1>
        </div>
        <div className="">
          <MasterCalendar />
        </div>
        <div className="app__faq app__background">
          <FAQS faqTitle="Recreational FAQ's" faqs={resFaq} />
        </div>
        <div className="app__faq app__background">
          <FAQS faqTitle="Competitive FAQ's" faqs={comFaq} />
        </div>
      </div>
      <div>
        <Footer />
      </div>
    </div>
  )
}

export default Resources